'use client';

import React, { FC } from 'react';

import PartFeedback from '@/components/part-feedback';
import PartPageBanner from '@/components/UI/part-page-banner';
import PartServicesDecor from '@/components/UI/part-services-decor';
import { ICategoryPage } from '@/contentful/utils/categoryPage';
import { IForm } from '@/contentful/utils/form';
import { IService } from '@/contentful/utils/services';
import { useLanguage } from '@/context/LanguageContext';

import PartServicesList from './part-services-list/part-services-list';

interface IPartServicesView {
  data: {
    servicesPages: ICategoryPage[];
    services: IService[];
    forms: IForm[];
  };
}

const PageServicesView: FC<IPartServicesView> = ({ data }) => {
  const { language } = useLanguage();

  const servicesPage = data.servicesPages.filter((item) => item.lang === language)[0];

  const servicesList = data.services.filter((item) => item.lang === language);

  const servicesForm = data.forms.filter((item) => item.lang === language)[0];

  const servicesPageBannerData = {
    title: servicesPage.title,
    imageDesktop: servicesPage.imageDesktop,
    imageMobile: servicesPage.imageMobile,
  };

  const servicesData = {
    lang: language,
    category: servicesPage.sectionFirstCategory,
    title: servicesPage.sectionFirstTitle,
    services: servicesList,
  };

  return (
    <>
      <PartPageBanner data={servicesPageBannerData} category />
      <PartServicesList data={servicesData} />
      <PartFeedback data={servicesForm} />
      <PartServicesDecor />
    </>
  );
};

export default PageServicesView;
